import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/img/icons/search.svg'
import _imports_1 from '../../assets/img/icons/tick-circle.svg'


const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "row mb-40 purchase-form-grid" }
const _hoisted_3 = { class: "col-lg-4" }
const _hoisted_4 = { class: "form-group mb-25" }
const _hoisted_5 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "form-group mb-25" }
const _hoisted_8 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "form-group mb-25" }
const _hoisted_12 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_13 = { value: null }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "col-lg-4" }
const _hoisted_16 = { class: "form-group mb-25" }
const _hoisted_17 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_18 = { value: null }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "col-12 purchase-search-block" }
const _hoisted_21 = { class: "form-group mb-25 position-relative" }
const _hoisted_22 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_23 = { class: "search-area style-two position-relative w-100" }
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = {
  key: 0,
  class: "search-results-dropdown position-absolute w-100 bg-white shadow-sm rounded-1 z-3 mt-1 overflow-auto"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_28 = { class: "fw-bold fs-14 text-black" }
const _hoisted_29 = { class: "fs-12 text-muted" }
const _hoisted_30 = { class: "text-end" }
const _hoisted_31 = { class: "text-primary fw-bold" }
const _hoisted_32 = { class: "fs-12 text-muted" }
const _hoisted_33 = {
  key: 1,
  class: "search-results-dropdown position-absolute w-100 bg-white shadow-sm rounded-1 z-3 mt-1 p-3 text-center text-muted"
}
const _hoisted_34 = {
  class: "delete-popup offcanvas offcanvas-end border-0",
  tabindex: "-1",
  id: "deletePopup"
}
const _hoisted_35 = { class: "offcanvas-body p-0" }
const _hoisted_36 = { class: "delete-success" }
const _hoisted_37 = { class: "text-white fw-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_SelectedProducts = _resolveComponent("SelectedProducts")!
  const _component_SubmitPurchase = _resolveComponent("SubmitPurchase")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, {
        pageTitle: "create_purchase",
        items: _ctx.breadcrumbItems,
        showHome: false
      }, null, 8, ["items"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("purchase_page.date")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.date) = $event)),
              class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white"
            }, null, 512), [
              [_vModelText, _ctx.form.date]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("purchase_page.reference_no")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.ref) = $event)),
              class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white",
              placeholder: _ctx.$t('purchase_page.reference_no')
            }, null, 8, _hoisted_9), [
              [_vModelText, _ctx.form.ref]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("purchase_page.supplier")), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.supplier_id) = $event)),
              class: "bg-white border-0 rounded-1 fs-14 text-optional"
            }, [
              _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.$t("purchase_page.choose_supplier")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suppliers, (supplier) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: supplier.id,
                  value: supplier.id
                }, _toDisplayString(supplier.name), 9, _hoisted_14))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.form.supplier_id]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("purchase_page.warehouse")), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.warehouse_id) = $event)),
              class: "bg-white border-0 rounded-1 fs-14 text-optional"
            }, [
              _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.$t("purchase_page.select_warehouse")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (warehouse) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: warehouse.id,
                  value: warehouse.id
                }, _toDisplayString(warehouse.name), 9, _hoisted_19))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.form.warehouse_id]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("purchase_page.choose_product")), 1),
            _createElementVNode("div", _hoisted_23, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchQuery) = $event)),
                onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args))),
                placeholder: _ctx.$t('purchase_page.scan_search_product'),
                class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white pe-3"
              }, null, 40, _hoisted_24), [
                [_vModelText, _ctx.searchQuery]
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("button", {
                type: "button",
                class: "bg-transparent border-0 position-absolute h-100 pt-0 py-0 px-2 pointer-events-none",
                tabindex: "-1",
                "aria-hidden": "true"
              }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Image"
                })
              ], -1))
            ]),
            (_ctx.showResults && _ctx.searchResults.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (product) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: product.id,
                      onClick: ($event: any) => (_ctx.addProduct(product)),
                      class: "search-result-item p-3 border-bottom cursor-pointer hover-bg-light",
                      style: {"cursor":"pointer"}
                    }, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_28, _toDisplayString(product.name), 1),
                          _createElementVNode("div", _hoisted_29, _toDisplayString(product.code), 1)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, "$" + _toDisplayString(product.cost), 1),
                          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("purchase_page.stock")) + ": " + _toDisplayString(_ctx.getProductStock(product)), 1)
                        ])
                      ])
                    ], 8, _hoisted_26))
                  }), 128))
                ]))
              : (_ctx.showResults && _ctx.normalizedSearchQuery.length >= 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.$t("purchase_page.no_standard_products_found")), 1))
                : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(_component_SelectedProducts, {
        products: _ctx.selectedProducts,
        onRemove: _ctx.removeProduct
      }, null, 8, ["products", "onRemove"]),
      _createVNode(_component_SubmitPurchase, {
        orderTax: _ctx.form.order_tax,
        "onUpdate:orderTax": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.order_tax) = $event)),
        discount: _ctx.form.discount,
        "onUpdate:discount": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.discount) = $event)),
        shipping: _ctx.form.shipping,
        "onUpdate:shipping": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.shipping) = $event)),
        status: _ctx.form.status,
        "onUpdate:status": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.status) = $event)),
        notes: _ctx.form.notes,
        "onUpdate:notes": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.notes) = $event)),
        paidAmount: _ctx.form.paid_amount,
        "onUpdate:paidAmount": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.paid_amount) = $event)),
        paymentMethodId: _ctx.form.payment_method_id,
        "onUpdate:paymentMethodId": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.payment_method_id) = $event)),
        paymentMethods: _ctx.paymentMethods,
        calculatedTax: _ctx.calculatedTax,
        grandTotal: _ctx.grandTotal,
        onSubmit: _ctx.handleSubmit
      }, null, 8, ["orderTax", "discount", "shipping", "status", "notes", "paidAmount", "paymentMethodId", "paymentMethods", "calculatedTax", "grandTotal", "onSubmit"]),
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _cache[15] || (_cache[15] = _createElementVNode("img", {
            src: _imports_1,
            alt: "Image"
          }, null, -1)),
          _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("purchase_page.product_deleted_from_list")), 1)
        ])
      ])
    ])
  ], 64))
}